import React from 'react';
import './../Styles/Footer.scss'

interface FooterProps {
    // define your props here
  }
  
  const Footer: React.FC<FooterProps> = (props) => {
    return (
        <div className="footer__container">
            <div className="footer">
                <div className="content">
                    <p>Chrystarin © {(new Date()).getFullYear()}</p>
                </div>
            </div>
        </div>
    );
  };

export default Footer;